export enum PermisstionValue {
    View = 'Xem',
    Create = 'Tạo',
    Edit = 'Chỉnh sửa',
    Confirm = 'Xác nhận',
    Approve = 'Duyệt',
    Remove = 'Loại bỏ',
    Export = 'Xuất',
    Import = 'Nhập'
}

export enum PermisstionId {
     //Permission - activities
    PERM_VIEW = "View",
    PERM_CREATE = "Create",
    PERM_EDIT = "Edit",
    PERM_CONFIRM = "Confirm",
    PERM_APPROVE = "Approve",
    PERM_REMOVE = "Remove",
    PERM_EXPORT = "Export",
    PERM_IMPORT = "Import",
}
export enum Function {
    A_P_HOMEPAGE = "Trang chủ",
    A_C_HOMEPAGE = "Homepage",
    A_P_PROFILE = "Hồ sơ cá nhân",
    A_C_PROFILE = "Profile",
    A_C_FORGOTPASSWORD = "ForgotPassword",
    A_C_CHANGEPASSWORD = "ChangePassword",
    A_P_DASHBOARD = "Thống kê",
    A_C_DASHBOARDDT = "DashboardDT",
    A_C_DASHBOARDBDK = "DashboardBDK",
    A_C_DASHBOARDLHLCLB = "DashboardLHLCLB",
    A_C_DASHBOARDLHLKHOI = "DashboardLHLKHOI",
    A_C_DASHBOARDLHLLOP = "DashboardLHLLOP",
    A_C_DASHBOARDLHLDT = "DashboardLHLDT",
    
    A_P_REGISTRATION = "Đăng ký",
    A_C_MANAGE_REGISTRATIONBDK = "ManageRegistrationBDK",
    A_C_MANAGE_REGISTRATIONDT = "ManageRegistrationDT",

    A_P_ENROLL = "Ghi danh",
    A_C_MANAGER_ENROLL = "ManageEnroll",

    A_P_REGISTRATION__FORM = "Biểu mẫu đăng ký",
    A_C_MANAGE_REGISTRATION_FORM = "ManageRegistrationForm",
    A_C_APPROVE_REGISTRATION_FORM = "ApproveRegistrationForm",
    A_P_MNCLBCUCVANG = "Phật tử CLB Cúc Vàng",
    A_C_MNCLBCUCVANG = "MNCLBCucVang",
    A_P_MNCLBTUOITRE = "Phật tử CLB Tuổi Trẻ",
    A_C_MNCLBTUOITRE = "MNCLBTuoiTre",
    A_P_MNCLBLAHAULA = "Khóa sinh CLB La Hầu La",
    A_C_MNCLBLAHAULA = "MNCLBLaHauLa",
    A_C_MNCLBLAHAULAKHOI = "MNCLBLaHauLaKhoi",
    A_C_MNCLBLAHAULALOP = "MNCLBLaHauLaLop",
    A_C_MNCLBLAHAULADT = "MNCLBLaHauLaDT",
    A_C_MNCLBLAHAULABTKS = "MNCLBLaHauLaBTKS",
    A_C_MNCLBLAHAULABT = "MNCLBLaHauLaBT",
    A_C_MNCLBLAHAULABTKHOI = "MNCLBLaHauLaBTKhoi",
    A_C_MNCLBLAHAULABTLOP = "MNCLBLaHauLaBTLop",
    A_C_MNCLBLAHAULABTDT = "MNCLBLaHauLaBTDT",
    A_C_MNCLBLAHAULABCN = "MNCLBLaHauLaBCN",
    A_C_MNCLBLAHAULAKLLHL = "MNCLBLaHauLaKLLHL",
    A_P_AUTHORIZATION = "Phân Quyền",
    A_C_MANAGE_ROLES = "ManageRoles",
    A_C_MANAGE_PERMISSIONS = "ManagePermissions",
    A_C_MANAGE_ROLEUSER = "ManageRoleUser",
    A_C_MANAGE_USERROLE = "ManageUserRole",
    A_C_SPCLBLHLBLD = "SupportCLBLHLBLD",
    A_C_SPCLBLHLKHOI = "SupportCLBLHLKHOI",
    A_C_SPCLBLHLLOP = "SupportCLBLHLLOP",
    A_C_SPCLBLHLDT = "SupportCLBLHLDT",
    A_C_MNCLBLAHAULABCNFKHOI = "MNCLBLaHauLaBCNFKHOI",
    A_C_MNCLBLAHAULAKHOIFKHOI = "MNCLBLaHauLaKhoiFKHOI",
    A_C_MNCLBLAHAULABCNFLOP = "MNCLBLaHauLaBCNFLOP",
}

export enum MaCLB {
    CLBCV= 'CLBCV',
    CLBTT= 'CLBTT',
    CLBLHL= 'CLBLHL'
}
export enum TenCLB {
    CLBCV_NAME= 'CLB Cúc Vàng',
    CLBTT_NAME= 'CLB Tuổi Trẻ',
    CLBLHL_NAME= 'CLB La Hầu La'
}
